import { TaskPicker as TaskPickerFeature } from '@features/task-picker'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useManagedGroupOutletContext } from '../../ManagedGroup'

interface Props {
  hidden: boolean
  onClose: () => void
  onTaskClick: (task: SelectedTask, options: { selected: boolean }) => void
}

export const TaskPicker: FC<Props> = ({ hidden, onClose, onTaskClick }) => {
  const { t } = useTranslation()
  const { selectedTaskIds, taskIdsWithEntries } = useManagedGroupOutletContext()

  return (
    <TaskPickerFeature
      disabledTaskIds={taskIdsWithEntries}
      hidden={hidden}
      onClose={onClose}
      onTaskClick={onTaskClick}
      selectedTaskIds={selectedTaskIds}
      tabs={['all-tasks', 'non-project'] as const}
      title={t('features.adminManagedGroups.taskPicker')}
      subtitle={t('features.adminManagedGroups.selectATask')}
    />
  )
}
